import type { ReactElement, ReactNode } from 'react';

export interface FullPageMessageProps {
  title: string;
  detail?: string;
  children?: ReactNode;
}

/** Centred status surface for bootstrap, empty and hard-error states. */
export function FullPageMessage({ title, detail, children }: FullPageMessageProps): ReactElement {
  return (
    <div className="flex h-full items-center justify-center px-6">
      <div className="text-center">
        {/* A heading, not a paragraph. This component *is* the whole page for 404s, load
            failures, the "restoring your session" state and the not-an-administrator block,
            so without it those pages have no h1 at all and a screen reader lands on a page
            with nothing to orient by. Styling stays small on purpose. */}
        <h1 className="text-sm font-medium text-session-text">{title}</h1>
        {detail ? <p className="mt-2 text-sm text-session-muted">{detail}</p> : null}
        {children ? <div className="mt-4">{children}</div> : null}
      </div>
    </div>
  );
}
